import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { OpenDialogProps } from '../../../../providers/Dialog.provider';
import styles from './PadAgreementPopup.module.scss';

const classes = vp.withStyles(styles);
const { Box, Icon } = vp;

const PadAgreementPopup: React.FC<OpenDialogProps<string>> = ({ onCancel }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.TransferFunds.PadAgreementPopup' });

  return (
    <Box
      flx="col"
      ai="center"
      boundary="shadow"
      background="white"
      position="relative"
      padding="24px"
      borderRadius="15px"
      gap="md"
      maxwidth="567px"
    >
      <Icon icon="close2" onClick={onCancel} height="14px" width="14px" className={classes('closeButton')} />

      <Box flx="col" ai="center" base="8" gap="lg">
        <h2 className={classes('header')}>{t('header')}</h2>
        <div className={classes('contentContainer')}>
          <div className={classes('content')}>
            <div className={classes('headerSub')}>{t('subHeader')}</div>
            <ol>
              <li>{t('clause1')}</li>
              <li>{t('clause2')}</li>
              <li>
                {t('clause3.title')}
                <ul>
                  <li>{t('clause3.recurring')}</li>
                  <li>{t('clause3.sporadic')}</li>
                </ul>
              </li>
              <li>{t('clause4')}</li>
              <li>{t('clause5')}</li>
              <li>{t('clause6')}</li>
              <li>{t('clause7')}</li>
              <li>{t('clause8')}</li>
              <li>
                {t('clause9.title')}
                <ul>
                  <li>{t('clause9.notDrawn')}</li>
                  <li>{t('clause9.revoked')}</li>
                  <li>{t('clause9.preNotification')}</li>
                </ul>
                <p>{t('clause9.declaration')}</p>
                <p>{t('clause9.dispute')}</p>
              </li>
              <li>{t('clause10')}</li>
              <li>{t('clause11')}</li>
              <li>{t('clause12')}</li>
              <li>{t('clause13')}</li>
              <li>{t('clause14')}</li>
              <li>
                <strong>{t('clause15.title')}</strong> {t('clause15.content')}
              </li>
              <li>{t('clause16')}</li>
            </ol>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default PadAgreementPopup;
